import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'dmsbasereact';
import { DmsReactQueryProvider, LanguageBaseContextProvider, setBuildConfiguration } from 'dmsbasereact';

import './index.css';
import { App } from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

try {
    let build_config_module = require("./build_config");
    setBuildConfiguration(build_config_module);
}
catch (_){
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <DmsReactQueryProvider>
      <LanguageBaseContextProvider>
        <App />
      </LanguageBaseContextProvider>
    </DmsReactQueryProvider>
  </BrowserRouter>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
